<template>
  <div class="modal hide fade in" id="modalSolicitudJuzgado" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Registro de Datos del Solicitante</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" id="closeModal">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
            <div v-if="AreaDatos.Area.AreaId!=21">
              <div class="form-group col-12">
                <label>Solicitante:</label>
                <CCuentas v-on:valorParaElPadre="cambioDeUsuarioReceptor"
                          :prefijo="enumeraciones.etiquetasDeHTML.Select"
                          :tipo="enumeraciones.tiposDeSelect.Seleccione"
                          :idDelInput="'filtroDeBusqueda_UsuarioReceptor'"
                          :parametros="parametros_UsuarioReceptor"
                          :valorDefinido="parametros_UsuarioReceptor.usuarioId"
                          :key="parametros_UsuarioReceptor.usuarioId"
                          :areaConsultaId="AreaDatos.Area.AreaId">
                </CCuentas>
              </div>
              <div class="form-group col-12">
                <label>Área:</label>
                <input type="text" class="form-control" v-model="SolicitudesJuzgados.AreaIdQueSolicita.Nombre" readonly>
              </div>
              <div class="form-group col-12">
                <label>Observaciones:</label>
                <textarea type="text" class="form-control" rows="3" v-model="SolicitudesDocumentos.ObservacionesJuzgado" placeholder="Escriba una observación si es necesario"></textarea>
              </div>
            </div>
            <div v-else>
              <div class="form-group col-12">
                <label>Área:</label>
                <CAreas
                  v-on:valorParaElPadre="cambioDeArea" 
                  :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                  :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                  :idDelInput="'catalogoAreas'" 
                  :parametros="parametros_Area" 
                  :valorDefinido="parametros_Area.areaId" 
                  >
                  </CAreas>
              </div>
              <div class="form-group col-12">
                <label>Solicitante:</label>
                <CCuentas v-on:valorParaElPadre="cambioDeUsuarioReceptor"
                          :prefijo="enumeraciones.etiquetasDeHTML.Select"
                          :tipo="enumeraciones.tiposDeSelect.Seleccione"
                          :idDelInput="'filtroDeBusqueda_UsuarioReceptor'"
                          :parametros="parametros_UsuarioReceptor"
                          :valorDefinido="parametros_UsuarioReceptor.usuarioId"
                          :key="parametros_UsuarioReceptor.usuarioId"
                          :areaConsultaId="parametros_Area.areaId">
                </CCuentas>
              </div>
              <div class="form-group col-12">
                <label>Observaciones:</label>
                <textarea type="text" class="form-control" rows="3" v-model="SolicitudesDocumentos.ObservacionesJuzgado" placeholder="Escriba una observación si es necesario"></textarea>
              </div>
            </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" id="botonCancelar" data-dismiss="modal">Cancelar</button>
          <button type="button" class="btn btn-dark" id="botonRegistrar" >Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import enumeraciones from '@/../static/js/enumeraciones'
import api from '@/../static/js/api'
import comun from '@/../static/js/comun'
import axios from 'axios'
import catalogos from '@/../static/js/catalogos'


export default {
    components:{
      CCuentas: catalogos.Cuentas.C001Usuario,
      CAreas : catalogos.ArchivoJudicial.C001Areas
    },
    data(){
      return{
        enumeraciones,
        SolicitudVolumenes: {},
        SolicitudesJuzgados :{
          UsuarioIdQuienSolicita: 0,
          AreaIdQueSolicita: {
              AreaId: 0,
              Nombre: ""
          },
        },
        SolicitudesDocumentos:{
          ObservacionesJuzgado: "",
        },
        parametros_UsuarioReceptor:{
                usuarioId: -1
            },
        parametros_Area:{
          areaId: -1
        }
      }
    },
    props:{
      inventarioDocumentoId: {
        type: Number,
        default: 0
        },
      AreaDatos: Object,
      volumenSolicitud: Array,
      incidenteSolicitud: Array
    },
    methods: {

      Mostrar: function () {
        $('#modalSolicitudJuzgado').modal('show');
        $('#botonCancelar').unbind('click').click(this.ModalClose);
        $('#closeModal').unbind('click').click(this.ModalClose);
        $('#botonRegistrar').unbind('click').click(this.RegistraSolicitud);
      },
      ModalClose: function(){
        $('#modalSolicitudJuzgado').modal('hide');
        this.$emit('dialogo', false);
      },
      cambioDeArea(datos){
            this.parametros_Area.areaId = parseInt(datos[0].target.value);
      },
      RegistraSolicitud(){
        if(this.ValidaCampos())
        {
            var peticion= {
                "SolicitudesJuzgados": {
                    "UsuarioIdQuienSolicita": {"IdUsuario": this.parametros_UsuarioReceptor.usuarioId},
                    "AreaIdQueSolicita": {"AreaId" : this.AreaDatos.Area.AreaId!=21 ? this.SolicitudesJuzgados.AreaIdQueSolicita.AreaId : this.parametros_Area.areaId}
                },
                "SolicitudesDocumentos":{
                    "InventarioDocumentoId": this.inventarioDocumentoId,
                    "FechaRegistro": null,
                    "TipoEstatusSolicitud": {"TipoEstatusSolicitudDocumentoId": 1},
                    "ObservacionesJuzgado": this.SolicitudesDocumentos.ObservacionesJuzgado,
                },
                VolumenesEnSolicitud: this.GeneramosListaVolumenes(),
                IncidentesEnSolicitud: this.GeneramosListaIncidentes()

            };
            comun.SeEstaCargandoInformacion(true);
            axios.post(api.conexion + api.ArchivoJudicial.NuevaSolicitudInterna, peticion,
            comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal))
                .then( respuesta => {
                    if(respuesta.data.SiHayError)
                    {
                        console.log(respuesta);
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                    }
                    else
                    {
                        comun.mensajeDeAlerta("Se ha generado la Solicitud del Documento", null, null);
                        comun.SeEstaCargandoInformacion(false);
                        this.ModalClose();
                    }
                    comun.SeEstaCargandoInformacion(false);

                }).catch(excepcion => {
                    console.log(excepcion);
                    comun.SeEstaCargandoInformacion(false);
                    comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                    
                });
        };
      },
      cambioDeUsuarioReceptor(datos){
            this.parametros_UsuarioReceptor.usuarioId = parseInt(datos.target.value);
        },
      GeneramosListaVolumenes(){
        var lista= [];
        this.volumenSolicitud.forEach(function (volumenId){
          lista.push({
            SolicitudDocumentoId: 0,
            VolumenId: volumenId})
          });
        return lista;
      },
      GeneramosListaIncidentes(){
        var lista= [];
        this.incidenteSolicitud.forEach(function (incidenteId){
          lista.push({
            SolicitudDocumentoId: 0,
            IncidenteId: incidenteId})
          });
        return lista;
      },
      ValidaCampos(){
        if(this.AreaDatos.Area.AreaId!=21)
        {
          if(this.parametros_UsuarioReceptor.usuarioId==-1)
          {
            comun.mensajeDeAlerta("Seleccione un Usuario para generar Solicitud", null, null);
            return false;
          }
        }
        if(this.AreaDatos.Area.AreaId==21)
        {
          if(this.parametros_Area.areaId==-1)
          {
            comun.mensajeDeAlerta("Seleccione una área solicitante", null, null);
            return false;
          }
          if(this.parametros_UsuarioReceptor.usuarioId==-1)
          {
            comun.mensajeDeAlerta("Seleccione un Usuario para generar Solicitud", null, null);
            return false;
          }
        }
        return true;
      }
    },
    mounted(){
        this.Mostrar();
        if(this.AreaDatos.Area.AreaId!=21)
        {
          this.SolicitudesJuzgados.AreaIdQueSolicita = this.AreaDatos.Area;
        }
        
    }
}
</script>
<style scoped>
  .modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1050;
    display: none;
    overflow: hidden;
    outline: 0;
  }

    input[type="text"]:read-only {
      background: #504f54;
    }

    input[type="text"]:read-only:focus {
      color: #fff;
    }
    .modal-content {
      background-color:  #7e7f74;
    }
    .modal-header {
        background-color:  #007573;
    }
</style>



// WEBPACK FOOTER //
// src/components/ArchivoJudicial/Comun/DatosJuzgadoSolicitud.vue